<template>
  <div class="profile-container">
    <div class="profile-icon">
      <span class="initial">{{ firstLetter }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileIcon',
  props: {
    username: {
      type: String,
      default: 'User'
    }
  },
  computed: {
    firstLetter() {
      return this.username.charAt(0).toUpperCase() || 'U'; 
    }
  }
}
</script>

<style scoped>
.profile-container {
  display: flex;
  align-items: center;
}

.profile-icon {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;
  background-color: var(--profile-icon-background);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  aspect-ratio: 1;
  box-sizing: border-box;
  border-radius: 50%;
}

.initial {
  font-size: 16px;
  font-weight: 500;
  color: var(--background-table);
  margin: 0;
  padding: 0;
  user-select: none;
  text-align: center;
}
</style>